import { BehaviorSubject } from 'rxjs';
import { Injectable, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { EcapCorporateIdentityService } from '../utility/corporate-identity.Service';
import { Location, isPlatformBrowser } from '@angular/common';
import { ShellDomainProvider } from '../utility/shell-domain.provider';

@Injectable()
export class TranslateService implements OnInit {
    private currentLangObservable: BehaviorSubject<string>;
    private langKeyValues: any;
    private currentLang: string;

    constructor(@Inject(PLATFORM_ID) private platformId: Object, private location: Location, private activatedRoute: ActivatedRoute, private router: Router, private ecapCorporateIdentityService: EcapCorporateIdentityService) {
        if (isPlatformBrowser(this.platformId)) {
            this.currentLang = document.cookie.replace(/(?:(?:^|.*;\s*)defaultLangKey\s*\=\s*([^;]*).*$)|^.*$/, "$1");
        }

        if (this.currentLang && this.currentLang) {
            this.currentLang = this.currentLang;
        } else {
            if (ShellDomainProvider['api'] && ShellDomainProvider['api']['defaultLangKey']) {
                this.currentLang = ShellDomainProvider['api']['defaultLangKey'];
            } else {
                this.currentLang = 'en';
            }
        }

        this.currentLangObservable = new BehaviorSubject(this.currentLang);
        this.currentLangObservable.subscribe((val) => {
            this.currentLang = val;
            // if(window){
            //     localStorage.setItem('Language',this.currentLang);
            // }
            this.ecapCorporateIdentityService.setLangKey(this.currentLang);
            // if (this.router.url !== '/') {
            //     //         this.router.navigateByUrl(this.router.url.split(';')[0] + `;lang=${this.currentLang}`);
            //     this.router.navigate([], {
            //         relativeTo: this.activatedRoute,
            //         queryParams: {
            //             lang: this.ecapCorporateIdentityService.getLangKey()
            //         },
            //         queryParamsHandling: 'merge',
            //         // preserve the existing query params in the route
            //         replaceUrl: true
            //     });
            // }
            //this.location.replaceState("/products/"+this.currentLang);

        });
        this.langKeyValues = {};
    }

    ngOnInit(): void {
    }
    public getCurrentLangObserable() {
        return this.currentLangObservable;
    }

    public getCurrentLang() {
        return this.currentLang;
    }

    public registerLangKeyVal(langs: any, componentActivatedRoute: any) {
        componentActivatedRoute.queryParams.subscribe(currentParams => {
            let storedLang;
            // if(window){
            //     storedLang = localStorage.getItem('Language');
            // }
            // else{
            //     storedLang = 'en'
            // }
            //const langPrefFromUrl = currentParams && currentParams.lang?currentParams.lang:storedLang;
            const langPrefFromUrl = currentParams && currentParams.lang ? currentParams.lang : this.ecapCorporateIdentityService.getLangKey();
            this.langKeyValues = { ...langs, ...this.langKeyValues };

            // emitting language change from URL/current language
            if (langPrefFromUrl === 'en' || langPrefFromUrl === 'fr' || langPrefFromUrl === 'de' || langPrefFromUrl === 'jp' || langPrefFromUrl === 'ru' || langPrefFromUrl === 'cz') {
                this.currentLangObservable.next(langPrefFromUrl);
            } else {
                this.currentLangObservable.next(this.currentLang);
            }
        });
    }

    public getTranslation(key): any {
        if (!this.langKeyValues[key]) {
            return 'KEY_MISSING';
        }

        return this.langKeyValues[key][this.currentLang];
    }

    public getTranslationObservabable(value): any {
        const translationSubject = new BehaviorSubject(this.langKeyValues[value][this.currentLang]);
        this.currentLangObservable.subscribe((val) => {
            translationSubject.next(this.langKeyValues[value][val]);
        });
        return translationSubject;
    }
}
